import React from "react";
import "./InstagramSection.scss";
import InstagramFeed from "./InstagramFeed";

export default function InstagramSection() {
  return (
    <section id="gallery" className="section">
      <div className="container">
        <header className="section__head">
          <h2>Galerija / Instagram</h2>
          <p className="muted">Jaunākie foto no mūsu Instagram profila.</p>
        </header>
        <InstagramFeed limit={9} />
      </div>
    </section>
  );
}
